module.exports = __webpack_public_path__ + "static/media/readiness-submitted-icon.24c5e422.svg";